export const getLabeledFieldName = (fieldName: string) => `${fieldName}_label`
